import { render, staticRenderFns } from "./Treetransfer.vue?vue&type=template&id=7a45e864&scoped=true&"
import script from "./Treetransfer.vue?vue&type=script&lang=js&"
export * from "./Treetransfer.vue?vue&type=script&lang=js&"
import style0 from "./Treetransfer.vue?vue&type=style&index=0&id=7a45e864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45e864",
  null
  
)

export default component.exports